<ng-template #fieldEditor>
    <div class="d-flex flex-column justify-content-center">
        <input
            (focus)="control.markAsTouched()"
            (input)="setControlValue($event)"
            (keydown)="onKeyDown($event)"
            (paste)="onPasteOrDrop($event)"
            (drop)="onPasteOrDrop($event)"
            [attr.max]="inputType === 'number' ? max : inputType === 'date' ? maxDate : null"
            [attr.maxlength]="inputType !== 'number' ? maxLength : null"
            [attr.min]="inputType === 'number' ? min : inputType === 'date' ? minDate : null"
            [attr.minlength]="inputType !== 'number' ? minLength : null"
            [attr.placeholder]="placeholderText"
            [attr.step]="inputType === 'number' ? step : null"
            [attr.type]="inputType"
            [class.disabled]="control.disabled"
            [class.input-invalid]="isInvalid(control)"
            [disabled]="control.disabled"
            [id]="createMinifiedName(controlDisplayName)"
            [name]="createMinifiedName(controlDisplayName)"
            [value]="displayValue ?? ''"
            class="input value-field-text w-100"
            [readonly]="isReadOnly"
        />
        <ul *ngIf="isInvalid(control)" class="d-flex flex-column m-0 p-0 validation-error">
            <li *ngFor="let error of validationErrors(controlDisplayName, control.errors)">
                <small class="text-danger w-100">{{ error }}</small>
            </li>
        </ul>
    </div>
</ng-template>
